import { useState } from 'react';
import type { BuildPriority, Platform } from '@hangar/shared';
import type { RunBuildPreset } from '@/shell/RunBuildContext';
import type { Inputs } from './runBuildModel';

/** The values the user edits in the Run build form, with their setters (the preset seeds the app and environment). */
export function useRunBuildFields(preset: RunBuildPreset) {
  const [projectId, setProjectId] = useState<string>('');
  const [appId, setAppId] = useState(preset.appId ?? '');
  const [profileSlug, setProfileSlug] = useState('');
  const [environment, setEnvironment] = useState(preset.environment ?? '');
  const [platforms, setPlatforms] = useState<Platform[]>([]);
  const [branch, setBranch] = useState('');
  const [commitSha, setCommitSha] = useState('');
  const [inputs, setInputs] = useState<Inputs>({});
  const [autoSubmit, setAutoSubmit] = useState<boolean | null>(null);
  const [priority, setPriority] = useState<BuildPriority>('normal');
  const [message, setMessage] = useState('');
  const values = { projectId, appId, profileSlug, environment, platforms, branch, commitSha, inputs, autoSubmit, priority, message };
  const set = { setProjectId, setAppId, setProfileSlug, setEnvironment, setPlatforms, setBranch, setCommitSha, setInputs, setAutoSubmit, setPriority, setMessage };
  return { values, set };
}

export type RunBuildFields = ReturnType<typeof useRunBuildFields>;
export type FieldValues = RunBuildFields['values'];
